<template>
<!--此组件仅手机刻字PC在使用-->
<div>
    <div v-show="showLettering">
        <div class="lettering-box">
            <h3 class="lettering-box-header">
                转轴刻字
                <div class="lettering-box-header-where" @mouseenter="noticeShow = true" @mouseleave="noticeShow = false">
                  哪里为转轴？
                </div>
                <img @click="closeDialog" class="lettering-box-header-iconClose" src="//p4.lefile.cn/product/adminweb/2021/08/03/3Bg8XXy391KuwuDypqptVix4J-3323.png" />
            </h3>
            <div class="lettering-box-content">
                <div class="lettering-box-content-left">
                    <div class="lettering-box-content-left-imgBox">
                      <img class="lettering-box-content-left-imgBox-img" :src="printUrl" alt="" />
                      <div 
                          v-if="currentPtMode == '2'" 
                          class="printText emoji" 
                          :style="{ fontFamily: currentFontFamily }"
                          v-html="validatePrintText">
                      </div>
                    </div>
                    <div class="lettering-box-content-left-noticeTop">
                      深色机型浅色刻字，浅色机型深色刻字
                    </div>
                    <div class="lettering-box-content-left-noticeBottom">
                      效果图只做参考，实际效果以刻字实物为准
                    </div>
                </div>
                <div class="lettering-box-content-right">
                    <div v-if="visibleTabs?.length > 0" class="lettering-box-content-right-tabs">
                        <div v-for="item in visibleTabs" @click="clickTab(item)" class="lettering-box-content-right-tabs-item" :class="currentPtMode == item.ptMode ? 'lettering-box-content-right-tabs-itemActive' : ''">{{ item.tabTitle }}</div>
                    </div>
                    <!--自定义刻字-->
                    <template v-if="currentPtMode == '2'">
                        <div class="lettering-box-content-right-inputBox">
                            <input ref="inputRef"
                            @input="inputChange" 
                            class="lettering-box-content-right-inputBox-input emoji"
                            :style="{ fontFamily: currentFontFamily }"
                            placeholder="请输入刻字内容..." 
                            @compositionstart="handleCompositionStart"
                            @compositionend="handleCompositionEnd"
                            v-model="printText"
                            @paste.prevent />
                            <img @click="clearLettering" class="lettering-box-content-right-inputBox-close" latag="latag_pc_购物车_C面私定弹层_0_null_清空刻字输入" src="//p3.lefile.cn/fes/cms/2023/02/28/7f4uwox77b16mmfjiuxyza34cai6an460347.png" />
                        </div>
                        <div :class="['lettering-box-content-right-remind', isExceedsLimit || showError ? 'error' : '']">文字长度不能超过6个汉字</div>
                        <!-- ====================== 新增：字体选择区域 ====================== -->
                        <div v-if="fontList?.length > 0" class="font-selector">
                          <p class="font-label">选择字体</p>
                          <div class="font-list">
                            <div 
                              v-for="(font, index) in fontList" 
                              :key="font.key"
                              class="font-item" 
                              :class="{ active: index === selectedFontIndex }"
                              @click="handleFontChange(font, index)"
                              :style="{ fontFamily: currentFontFamily }"
                            >
                              <span class="font-preview" :style="{ fontFamily: font.fontId + '-font' }">Aa</span>
                              <span class="font-name" :style="{ fontFamily: font.fontId + '-font' }">{{ font.fontName }}</span>
                            </div>
                          </div>
                        </div>
                        <!-- ====================== 新增结束 ====================== -->
                        <div class="lettering-box-content-right-emojisBox">
                            <div class="lettering-box-content-right-emojisBox-item" v-for="item in emojiList">
                                  <span :class="['emoji_item_font','emoji','lenovo-emoji','cell','JS_emoji_cell', 
                                  item.id === pressEmojiId ? 'cellChecked' : '',]" 
                                  @mousedown="pressEmojiId = item.id"
                                  @mouseup="pressEmojiId = ''"
                                  @click="handleCheckEmoji"
                                  :emoji="item.code" 
                                  v-html="item.code">
                                  </span>
                            </div>
                        </div>
                    </template>
                    <!--签名刻字-->
                    <template v-else>
                        <div class="lettering-box-content-right-signatureBox">
                          <div v-for="item in subList" class="lettering-box-content-right-signatureBox-item">
                            <div @click="handleClickImg(item)" :class="
                            activeImg.ptPicCode == item.ptPicCode ? 'activeImgClass' : 'defualtImgClass'" class="lettering-box-content-right-signatureBox-item-img">
                                <img :src="item.ptEffectUrl" alt="" />
                            </div>
                            <div class="lettering-box-content-right-signatureBox-item-name">
                              {{item.tabContent}}
                            </div>
                        </div>
                              
                        </div>
                    </template>
                    <div class="lettering-box-content-right-footer">
                        <div class="lettering-box-content-right-footer-price">
                          刻字价:¥{{ cSideItem?.activityPrice ?? '' }}<s v-if="cSideItem && cSideItem.activityPrice != cSideItem.price">¥{{ cSideItem.price }}</s>
                        </div>
                        <div class="lettering-box-content-right-footer-cancel" @click="closeDialog" latag="latag_pc_购物车_私定弹层_0_null_C面喷绘取消">取消</div>
                        <div class="lettering-box-content-right-footer-ok" @click="handleSubmit" latag="latag_pc_购物车_私定弹层_0_null_C面喷绘取消">确定</div>
                    </div>
                </div>
            </div>
            <Notice v-if="noticeShow" deviceType="mobilePhone" />
        </div>
        <div class="lettering-mask"></div>
    </div>
</div>

</template>
<script setup>
import { ref, watchEffect, computed, nextTick, watch, onMounted } from 'vue';
import API from '@api/index.js';
import Notice from './Notice.vue';
import { toast } from '@shared/utils/biz_utils';
import { PersonalReducer, createPrintEmoji } from './util';
import { storeToRefs } from 'pinia';
import usePrivateStore from '@shared/store/usePrivateStore';
const store = usePrivateStore();
const { modalVisible, privateInfo, currentClickProduct } = storeToRefs(store);
import useGoodsStore from "@shared/store/useGoodsStore";
const goodsStore = useGoodsStore();
import { Bridge } from "@shared/bridge";
import {$array, $event_publisher, $util,$cookie} from "@util/util.js";
import Constant from "@constant/index.js";
import { cloneDeep } from 'lodash-es';

const showLettering = ref(true);
const machineInfo = ref(null);
//签名信息
const signatureInfo = ref(null);
const customInfo = ref(null);
const printUrl = ref(null);
// 当前选中是签名刻字还是自定义刻字 3||2
const currentPtMode = ref('2');
const currentPtType = ref('2');
const currentPtPicCode = ref('');
const tabslist = ref([]);
// tabTitle 为空的 tab 不参与展示与激活
const visibleTabs = computed(() => (tabslist.value || []).filter(item => item?.tabTitle));
// position 接口 C面[0]，用于展示刻字价（活动价+划线原价）
const cSideItem = ref(null);
const emojiList = ref([]);
const noticeShow = ref(false);
// 手机刻字官方签名刻字的数组
const subList = ref([]);

const activeImg = ref({});
// emoji渲染后与原始字符的map
const emojiMap = ref(new Map());
const inputRef = ref();
// 刻字的值
const printText = ref("");
// 经过风控校验后的文案
const validatePrintText = ref("");
// 按下的emojiID
const pressEmojiId = ref("");
const showError = ref(false);
let errorTimer = null;
let timer = null;
let inputLock = false;
// 最大输入限制长度
const MAX_LIMIT_WORDS = 6;
// 表情长度 当前组件只有手机刻字用 手机刻字为1
const emojiLength = ref(1);

// ====================== 新增：字体相关配置 ======================
// TODO fontList从postion接口里machineInfo.mobileList里ptMode为‘2’的fontList取
// ====================== ✅ 字体：从接口取，无则兜底 ======================
const fontList = ref([]); // 最终使用的字体列表
const selectedFontIndex = ref(0);
const selectedFontId = ref('');      
const selectedFontName = ref('');
const selectedTtfUrl = ref('');
const currentFontFamily = ref(''); // 页面渲染用

const DEFAULT_FONT_FAMILY = `Helvetica Neue, Helvetica, Arial, Microsoft Yahei, 微软雅黑, PingFang SC, Heiti, sans-serif, SimSun, serif, 'lenovo-emoji', 'Apple Color Emoji', 'Segoe UI Emoji'`;
// 动态加载接口返回的字体
const loadFontsFromList = (list) => {
  let style = document.createElement('style');
  let css = '';
  list.forEach(item => {
    if (item.ttfUrl) {
      css += `
        @font-face {
          font-family: '${item.fontFamily}';
          src: url('${item.ttfUrl}') format('truetype');
          font-weight: normal;
          font-style: normal;
        }
      `;
    }
  });
  style.innerHTML = css;
  document.head.appendChild(style);
};

// 添加方法：设置 fallback 字体
const setFallbackFontFamily = () => {
  currentFontFamily.value = DEFAULT_FONT_FAMILY;
  // 同时清除选中的字体变量
  selectedFontIndex.value = -1;
  selectedFontId.value = '';
  selectedFontName.value = '';
  selectedTtfUrl.value = '';
};

// 监听 fontList 变化，自动加载字体
watch(fontList, (newList) => {
  if (newList.length) {
    loadFontsFromList(newList);
  }
}, { immediate: true });
// 处理字体列表（接口优先，无则默认）
const initFontList = (C_Face) => {
  const customItem = C_Face?.[0] || {}
  let apiFontList = customItem.fontList || [];
  // 有选择字体功能
  if (apiFontList?.length > 0) {
    fontList.value = apiFontList.map(item => ({
      fontId: item.fontId,
      fontName: item.fontName,
      ttfUrl: item.ttfUrl,
      fontFamily: item.fontId + '-font'
    }));
    // 有字体列表时，加载字体样式（已有，无需重复）
    if (fontList.value.length) {
      selectedFontIndex.value = 0;
      const first = fontList.value[0];
      selectedFontId.value = first.fontId;
      selectedFontName.value = first.fontName;
      selectedTtfUrl.value = first.ttfUrl;
      currentFontFamily.value = `${first.fontFamily}, 'lenovo-emoji', 'Apple Color Emoji', 'Segoe UI Emoji', sans-serif`;
    }
  // 没有选择字体功能  
  } else {
    fontList.value = [];
    setFallbackFontFamily();
  }
};

// 字体切换事件
const handleFontChange = (font, index) => {
  selectedFontIndex.value = index;
  selectedFontId.value = font.fontId;
  selectedFontName.value = font.fontName;
  selectedTtfUrl.value = font.ttfUrl;
  // 拼接完整的字体栈，最后加上 emoji fallback
  currentFontFamily.value = `${font.fontFamily}, 'lenovo-emoji', 'Apple Color Emoji', 'Segoe UI Emoji', sans-serif`;
};
// ====================== 字体逻辑结束 ======================
const handleLettering = async () => {
  try{
      const p = cloneDeep(usePrivateStore().currentClickProductCode);
      // 列表带过来的当前私定信息
      const { privateInfo } = cloneDeep(store);
      // 原选中是否为自定义刻字：仅此时才回显刻字文案（原选明星刻字被下架强制切到自定义时，输入框应为空）
      const isOriginalCustom = privateInfo.ptmode == '2';
      currentPtMode.value = cloneDeep(privateInfo.ptmode);
      currentPtType.value = cloneDeep(privateInfo.pttype);
      // 发起position查询可选私定信息
      const privateInfoRes = await API.getPersonalGoods(p);
      machineInfo.value = privateInfoRes?.t?.machineInfo;
      tabslist.value = privateInfoRes?.t?.machineInfo?.mobileList;
      // 刻字价数据来源：position 接口 C面[0]
      cSideItem.value = privateInfoRes?.t?.['C面']?.[0] || null;
      // 初始化字体列表
      initFontList(privateInfoRes?.t['C面']);
      if (fontList.value.length) {
          // 如果存在已保存的字体ID，则匹配并选中
          const savedFontId = privateInfo.fontId;
          if (savedFontId) {
            const idx = fontList.value.findIndex(f => f.fontId === savedFontId);
            if (idx !== -1) {
              handleFontChange(fontList.value[idx], idx);
            } else {
              // 未匹配到，默认选中第一个
              handleFontChange(fontList.value[0], 0);
            }
          } else {
            // 没有保存的字体，默认选中第一个
            handleFontChange(fontList.value[0], 0);
          }
      } else {
          // 没有字体列表时，设置 fallback 字体栈（见修改二）
          setFallbackFontFamily();
      }
      // 只在“tabTitle 非空”的 tab 中查找当前 ptMode；若被后端隐藏则强制切到第一个有效 tab
      const validList = (privateInfoRes?.t?.machineInfo?.mobileList || []).filter(item => item?.tabTitle);
      const findIndex = validList.findIndex(item => item?.ptMode === currentPtMode.value);
      // 是否为“原选择已失效”被强制切到其他 tab 的场景
      const isForcedSwitch = findIndex == -1;
      if(findIndex == -1){
        currentPtMode.value = validList?.[0]?.ptMode || privateInfoRes?.t?.machineInfo?.mobileList?.[0]?.ptMode || '2';
      }
      // 签名刻字
      subList.value = cloneDeep(privateInfoRes?.t?.machineInfo?.mobileList?.find(item => item?.ptMode == '3')?.subList) || [];
      // 签名信息
      signatureInfo.value = cloneDeep(privateInfoRes?.t?.machineInfo?.mobileList?.find(item => item?.ptMode == '3')) || {};
      // 自定义信息
      customInfo.value = privateInfoRes?.t?.machineInfo?.mobileList?.find(item => item?.ptMode == '2');
      if(currentPtMode.value == '3'){
        const matched = signatureInfo.value?.subList?.find(item => item?.ptPicCode == privateInfo.ptpicCode);
        if(isForcedSwitch || !matched){
          // 强制切换 或 原签名下架 → 不做默认选中，等用户主动勾选；预览显示干净机器图
          activeImg.value = {};
          printUrl.value = privateInfoRes?.t?.machineInfo?.url;
        }else{
          activeImg.value = matched;
          printUrl.value = matched.ptUrl;
        }
        validatePrintText.value = '';
      }else{
        printUrl.value = privateInfoRes?.t?.machineInfo?.url;
        validatePrintText.value = isOriginalCustom ? privateInfo.ptword : '';
      }
      // 查询刻字的表情
      API.getPersonalCarveEmojis()
      .then(res => {
        if(res.t.status === 0){
            emojiList.value = res.t.res.emojiList || [];
            //初始化时是自定义刻字 才将列表的ptword给printText
            if (privateInfo.ptword && currentPtMode.value == '2' && isOriginalCustom) {
              const ptWord = privateInfo.ptword;
              printText.value = createPrintEmoji(ptWord);
            }
        }
      }).catch((err) => {});
  }catch(err){
    console.log('info catch：',err);
  }
}
const clearLettering = () => {
  printText.value = '';
}

const clickTab = (item) => {
  currentPtMode.value = item.ptMode;
  currentPtType.value = item.ptType;
  if(item.ptMode == '3'){
    if(activeImg.value?.ptPicCode){
      printUrl.value = activeImg.value.ptUrl;
    }else{
      activeImg.value = subList.value[0];
      printUrl.value = subList.value[0].ptUrl;
    }
  }else{
    printUrl.value = machineInfo.value?.url;
  }
}
const closeDialog = () => {
  printText.value = '';
  printUrl.value = null;
  showLettering.value = false;
  document.querySelector("body").classList.remove("bodyScrollerHide");
}
const handleClickImg = (item) => {
  activeImg.value = item;
  printUrl.value = item.ptUrl;
}
const getEmojiMap = () => {
  const els = document.getElementsByClassName("JS_emoji_cell");
  const newEmojiMap = new Map();
  for (const elItem of els) {
    const key = elItem.innerHTML;
    const value = elItem.getAttribute("emoji");
    newEmojiMap.set(key, value);
  }
  return newEmojiMap;
};
const inputChange = (e) => {
  if (inputLock) {
    return;
  }
  const val = e.target.value;
  if (calculateInputLength(val) > MAX_LIMIT_WORDS) {
    printText.value = cutInputWords(val);
    triggerErrorTips();
  } else {
    printText.value = val;
  }
  if (printText.value.length === 0) {
    validatePrintText.value = "";
  }
}
//如果超过15个字符长度 截取到15
const cutInputWords = (words) => {
  let count = 0;
  for (let index = 0; index < words.length; index++) {
    const word = words[index];
    const isEmoji = emojiMap.value?.get(word);
    if (isEmoji) {
      count = count + emojiLength.value;
    } else {
      count = count + 1;
    }
    if (count > MAX_LIMIT_WORDS) {
      return words.substring(0, index);
    }
  }
};

// 中文输入开始
const handleCompositionStart = () => {
  inputLock = true;
};

// 中文输入结束
const handleCompositionEnd = (e) => {
  if (!inputLock) {
    return;
  }
  inputLock = false;
  const oldValue = printText.value;
  const selectionStart = inputRef.value.selectionStart - e.data.length;
  const newValue =
    oldValue.substring(0, selectionStart) + e.data + oldValue.substring(selectionStart);

  if (calculateInputLength(newValue) > MAX_LIMIT_WORDS) {
    triggerErrorTips();
  }

  const restLen = Math.max(MAX_LIMIT_WORDS - calculateInputLength(oldValue), 0);
  const restWords = e.data.substring(0, restLen);
  const confirmNewValue =
    oldValue.substring(0, selectionStart) + restWords + oldValue.substring(selectionStart);

  printText.value = confirmNewValue;
};
const handleRisk = async (value) => {
  const text = getConvertEmoji(value);
  const res = await API.riskCheck({
    sts: "e40e7004-4c8a-4963-8564-31271a8337d8",
    text: text,
  });
  if (res?.resps?.ret === "0" && res?.resps?.isLegal === "0") {
    return true;
  } else {
    toast("重新提交您的刻字内容，您可以尝试输入名字或祝福等，为设备添加个性风格");
    return false;
  }
}
const getConvertEmoji = (value) => {
  let convertEmoji = "";
  value.split("").reduce((result, item) => {
    convertEmoji += emojiMap.value.get(item) ? emojiMap.value.get(item) : item;
    return result;
  }, convertEmoji);
  return convertEmoji;
};
const handleCheckEmoji = (e) => {
  const oldValue = printText.value;
  const selectionStart = inputRef.value.selectionStart;
  const newValue = oldValue.substring(0, selectionStart) + e.target.innerText + oldValue.substring(selectionStart);
  inputRef.value.focus();
  if (calculateInputLength(newValue) > MAX_LIMIT_WORDS) {
    triggerErrorTips();
    return;
  }
  printText.value = newValue;
  // 在移动光标前必须要先聚焦
  inputRef.value.setSelectionRange(selectionStart + 1, selectionStart + 1);
};
//计算emoji+普通字符的总长度
const calculateInputLength = (words) => {
  let count = 0;
  for (let index = 0; index < words.length; index++) {
    const word = words[index];
    const isEmoji = emojiMap.value?.get(word);
    if (isEmoji) {
      count = count + emojiLength.value;
    } else {
      count = count + 1;
    }
  }
  return count;
};
// 触发错误提示, 2s后自动消失
const triggerErrorTips = () => {
  showError.value = true;
  if (errorTimer) {
    clearTimeout(errorTimer);
  }
  errorTimer = setTimeout(() => {
    showError.value = false;
  }, 2000);
};
//文字长度大于6
const isExceedsLimit = computed(() => {
  return calculateInputLength(printText.value) > MAX_LIMIT_WORDS;
});

const handleSubmit = async () => {
  // 自定义刻字 需要发起风控接口
  if(currentPtMode.value == '2'){
     if (!printText.value.replace(/\s+/g, "")) {
      toast("请输入刻字内容");
      return;
    }
    if (isExceedsLimit.value) {
      toast("文字长度不能超过6个汉字");
      return;
    }
    try{
      const isSuccess = await handleRisk(printText.value);
      if (isSuccess) {
        modifyData();
      }
    }catch(err){
      console.log('riskCheck pc失败', err); 
    }
  }else{
    // 明星签名 tab 下必须已选中一张签名（覆盖强制切换、原签名下架等未默认选中场景）
    if(!activeImg.value?.ptPicCode){
      toast('请选择签名');
      return;
    }
    modifyData();
  }
};

const modifyData = () => {
  let params = { 
    price: privateInfo.value.price, 
    priceID: privateInfo.value.priceID, 
    ptmode: currentPtMode.value, 
    ptside: privateInfo.value.ptside, 
    pttype: currentPtType.value, 
    ptcode: privateInfo.value.ptcode,
  };
  // 自定义刻字
  if(currentPtMode.value == '2'){
    params.fontId = selectedFontId.value;
    params.fontName = selectedFontName.value;
    params.ttfUrl = selectedTtfUrl.value;
    params.ptword = printText.value;
    if(machineInfo.value?.mobileList?.length > 0){
      params.pturl = machineInfo.value.mobileList.find(item => item.ptMode == '2').ptUrl;
    }else{
      params.pturl = machineInfo.value.ptUrl;
    }
    
  }else{
    params.ptword  = activeImg.value.ptWord;
    params.spurl = activeImg.value.ptEffectUrl;
    params.ptpicCode = activeImg.value.ptPicCode;
    params.pturl = activeImg.value.ptUrl;
  }
  let personalizations = [];
  personalizations.push(params);
  API.modifyItemFromCart({
    itemId:currentClickProduct.value.itemId,
    terminal: window._terminal,
    shopId: window._shopId,
    opsType: 4,
    personalization: JSON.stringify(personalizations)
  }).then(async modifyRes => {
    printText.value = '';
    printUrl.value = null;
    showLettering.value = false;
    document.querySelector("body").classList.remove("bodyScrollerHide");
    //价格变动
    $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, modifyRes.t);
    //重新渲染购物车
    $event_publisher.broadcast(Constant.EVENT_KEY.RERENDER_CART, modifyRes.t); 
    
    //const res2 = await goodsStore.getGoodsList();
    //if (res2.success) {
    //  Bridge.emit(Bridge.EventType.renderCart, res2);
    //} else {
    //  toast(res2.resultMsg);
    //}
    //Bridge.emit(Bridge.EventType.ChangePersonal, data);
  }).catch(err => {
    
  }).finally(() => {})
}

watch(
  () => printText.value,
  (text) => {
    if (timer) {
      clearTimeout(timer);
    }
    if (isExceedsLimit.value || text.length === 0) {
      return;
    }
    timer = setTimeout(async () => {
      const isSuccess = await handleRisk(text);
      if (isSuccess) {
        validatePrintText.value = text;
      }
    }, 1000);
  }
);

watchEffect(async () => {
  if (currentPtMode.value == '2' && machineInfo.value?.machineProductType === 'Z' && showLettering.value == true) {
      //console.log('emoji区域出现');
      await nextTick();
      inputRef.value.value = printText?.value;
      emojiMap.value = getEmojiMap();
  }else{
      //console.log('emoji区域隐藏');
  }
});

watch(() => showLettering.value, async (newValue) => {
    if(newValue){
      document.querySelector("body").classList.add("bodyScrollerHide");
      handleLettering();
    }
},{ immediate: true });
</script>
<style lang="less" scoped>
//@import "./emoji.css";

.lettering-box{
  width: 1000px;
  height: 614px;
  box-sizing: border-box;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 99;
  font-size: 14px;
  color: #252525;
  display: flex;
  flex-direction: column;
  &-header{
    width: 100%;
    height: 60px;
    background: #F6F6F6;
    font-family: 微软雅黑, Arial;
    font-size: 20px;
    color: #3C4463;
    line-height: 60px;
    font-weight: 400;
    padding-left: 60px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    &-where{
      margin-left: 9px;
      font-size: 12px;
      color: #CDCDCD;
      letter-spacing: 0;
      font-weight: 400;
      cursor: pointer;
    }
    &-iconClose{
      position: absolute;
      right: 21px;
      top: 21px;
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
  }
  &-content{
    height: 100%;
    margin-top: -60px;
    padding-top: 60px;
    box-sizing: border-box;
    display: flex;
    &-left{
      display: flex;
      flex-direction: column;
      width: 455px;
      padding-left: 100px;
      padding-top: 21.5px;
      box-sizing: border-box;
      &-imgBox{
        position: relative;
        &-img{
          max-width: 100%;
          max-height: 100%;
        };
      }
      &-noticeTop{
        font-size: 12px;
        color: #454545;
        text-align: center;
        font-weight: 400;
        margin-top: 18.5px;
      }
      &-noticeBottom{
        font-size: 12px;
        color: #979797;
        text-align: center;
        font-weight: 400;
        margin-top: 4px;
      }
    }
    &-right{
      display: flex;
      flex-direction: column;
      flex: 1;
      padding-left: 108.59px;
      padding-right: 63.5px;
      box-sizing: border-box;
      padding-top: 60px;
      position: relative;
      &-tabs{
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        user-select: none;
        &-item{
          display: flex;
          flex-direction: column;
          padding-bottom: 10px;
          font-size: 15px;
          color: #31333B;
          line-height: 18px;
          margin-right: 16px;
          box-sizing: border-box;
          cursor: pointer;
        }
        &-itemActive{
          font-weight: bold;
          position: relative;
        }
        &-itemActive::after{
          content: '';
          position: absolute;
          width: 40px;
          height: 4px;
          left: 50%;
          bottom: 0;
          background-image: linear-gradient(105deg, #8CFF32 0%, #12A8FF 100%);
          border-radius: 2px;
          -webkit-transform: translateX(-50%);
          -ms-transform: translateX(-50%);
          -o-transform: translateX(-50%);
          -moz-transform: translateX(-50%);
          transform: translateX(-50%);
        }
      }
      &-inputBox{
        position:relative;
        &-input{
          width: 100%;
          height: 40px;
          padding-left: 12px;
          opacity: 0.9;
          background: #ffffff;
          border: 1.2px solid #434343;
          border-radius: 1px;
          box-sizing: border-box;
          letter-spacing: 2px;
          font-size: 16px !important;
        }
        &-close{
          position: absolute;
          top:10px;
          right:20px;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }
      &-remind{
        font-size: 12px;
        color: #AFAFAF;
        letter-spacing: 0;
        font-weight: 400;
        margin-top: 14px;
      }
      &-emojisBox{
        margin-top: 10px;
        width: 100%;
        height: 160px;
        padding: 0 7px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        overflow-y: scroll;
        &-item{
          width: 32px;
          height: 32px;
          margin: 0 6px;
          margin-bottom: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
        }
      }
      &-footer{
        height: 34px;
        width: 100%;
        position: absolute;
        bottom: 38px;
        left: 0;
        padding-left: 108.59px;
        padding-right: 63.5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        &-price{
          font-size: 12px;
          color: #252525;
          text-align: center;
          font-weight: 500;
          s{
            margin-left: 5px;
            color: #979797;
            font-weight: 400;
          }
        }
        &-cancel{
          width: 109px;
          height: 100%;
          box-sizing: border-box;
          display: inline-block;
          text-align: center;
          line-height: 34px;
          opacity: 0.9;
          background: #FFFFFF;
          border: 1px solid #D6D6D6;
          border-radius: 1px;
          margin-right: 18px;
          margin-left: 17.5px;
          cursor: pointer;
        }
        &-ok{
          display: inline-block;
          text-align: center;
          line-height: 34px;
          width: 109px;
          height: 100%;
          box-sizing: border-box;
          background-clip: padding-box;
          border: 1px solid transparent;
          opacity: 0.9;
          background: #FFFFFF;
          border-radius: 1px;
          background-clip: padding-box, border-box;
          background-origin: padding-box, border-box;
          background-image: linear-gradient(to right, #ffffff, #ffffff), linear-gradient(to right, #DCF941, #FF5F5F, #82D4A0, #53C1CF, #28B0FD);
          cursor: pointer;
        }
      }
      &-signatureBox{
        display: flex;
        flex-wrap: wrap;
        &-item{
          display: flex;
          flex-direction: column;
          margin-right: 10px;
          margin-top: 10px;
          cursor: pointer;
          width:120px;
          &-img{
            width: 92px;
            height: 92px;
            box-sizing: border-box;
            border: 2px solid;
            border-color: transparent;
            border-radius: 1px;
            img{
              max-width: 100%;
              max-height: 100%;
            }
          }
          &-name{
            font-size: 12px;
            color: #000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: wrap;
            width: 100px;
            margin-top: 8px;
          }
        }
      }
    }
  }
}

.lettering-mask{
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.3;
  z-index: 9;
  position: fixed;
  top: 0;
  left: 0;
}
.activeImgClass{
  border-image: linear-gradient(140deg, #DCF941 0%, #28B0FD 106%) 2;
}
.defualtImgClass{
  border-image: linear-gradient(140deg, #E7E7E7) 2;
}
.cell {
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  margin: 8px 7px;
  font-size: 20px;
  cursor: pointer;
  border: 1px solid transparent;
  &.cellChecked {
    box-sizing: border-box;
    border-radius: 4px;
    background-clip: padding-box;
    border: 1px solid transparent;
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(to bottom, #ffffff, #ffffff),
    linear-gradient(to bottom, #d2ffad, #a1dcff);
  }
}

.printText {
  position: absolute;
  right: 20%;
  top: 40.5%;
  font-size: 14px;
  color: #646464;
  letter-spacing: 1px;
  font-weight: 400;
  white-space: pre-wrap;
  height: 20px;
  line-height: 20px;
}
.error {
  color: red;
}
/* ====================== 字体选择器样式 ====================== */
.font-selector {
  margin: 16px 0;
}
.font-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
}
.font-list {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.font-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 2px !important;
  padding-bottom: 10px !important;
  cursor: pointer;
  position: relative;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #e0e0e0;
  color: #979797;
  width: 78px;
  height: 56px;
  box-sizing: border-box;
  font-size: 14px;
  user-select: none;
}
.font-item.active {
  border-color: transparent;
  color: #2D3248;
}
.font-item.active::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 6px;
  padding: 1px;
  background: linear-gradient(138deg, #8DFF32 14%, #13A8FF 89%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}
.font-preview,
.font-name {
  position: relative;
  z-index: 1;
}
.font-preview {
  font-size: 14px !important;
  line-height: 18px !important;
  height: 18px !important;
  width: 18px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size-adjust: none;
}
.font-name {
  font-size: 13px;
}
/* ====================== 字体选择器样式 ====================== */
</style>